import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Percent, Boxes, RotateCcw } from "lucide-react";

export default function BulkUpdatePanel({ filter, total, onDone }) {
  const [pct, setPct] = useState("");
  const [stock, setStock] = useState("");
  const [busy, setBusy] = useState(false);

  const scope = [filter.category_name && `Kategori: ${filter.category_name}`, filter.brand && `Marka: ${filter.brand}`, filter.q && `Arama: "${filter.q}"`]
    .filter(Boolean).join(" · ") || "TÜM ÜRÜNLER";

  const run = async (payload, msg) => {
    if (!window.confirm(`${total} ürün etkilenecek (${scope}).\n${msg}\nDevam edilsin mi?`)) return;
    setBusy(true);
    try {
      const r = await api.post("/admin/products/bulk-update", {
        category_id: filter.category_id || null, brand: filter.brand || null, q: filter.q || null, all: true, ...payload,
      });
      toast.success(`${r.data.matched} ürün güncellendi`);
      setPct(""); setStock(""); onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Güncellenemedi");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="bulk-update-panel" className="kz-card p-5 mb-4 border-l-4 border-l-brand">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-4">
        <h3 className="font-display font-black">Toplu Fiyat & Stok Güncelleme</h3>
        <span data-testid="bulk-scope" className="text-xs text-ink-500">Hedef: <b className="text-ink-900">{scope}</b> · {total} ürün</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="text-xs font-semibold mb-1 flex items-center gap-1"><Percent size={12}/> Fiyat değişimi (%)</div>
          <div className="flex gap-2">
            <input data-testid="bulk-price-pct" type="number" step="0.5" value={pct} onChange={e => setPct(e.target.value)}
              placeholder="Örn: 10 veya -5" className="border border-ink-200 px-3 py-2 flex-1 min-w-0"/>
            <button data-testid="bulk-price-apply" disabled={busy || pct === ""} onClick={() => run({ price_change_pct: parseFloat(pct) }, `Fiyatlar %${pct} değişecek.`)}
              className="kz-btn-primary text-sm py-2 px-4">Uygula</button>
            <button data-testid="bulk-price-reset" disabled={busy} title="SGS fiyatına dön" onClick={() => run({ reset_markup: true }, "Fiyat farkı sıfırlanıp SGS liste fiyatına dönülecek.")}
              className="kz-btn-outline text-sm py-2 px-3"><RotateCcw size={14}/></button>
          </div>
          <p className="text-[11px] text-ink-500 mt-1">SGS liste fiyatına eklenir; senkronizasyonda korunur.</p>
        </div>
        <div>
          <div className="text-xs font-semibold mb-1 flex items-center gap-1"><Boxes size={12}/> Stok adedi</div>
          <div className="flex gap-2">
            <input data-testid="bulk-stock-value" type="number" min="0" value={stock} onChange={e => setStock(e.target.value)}
              placeholder="Örn: 0 (tükendi) veya 100" className="border border-ink-200 px-3 py-2 flex-1 min-w-0"/>
            <button data-testid="bulk-stock-apply" disabled={busy || stock === ""} onClick={() => run({ stock_value: parseInt(stock) }, `Stok ${stock} olarak sabitlenecek.`)}
              className="kz-btn-dark text-sm py-2 px-4">Uygula</button>
            <button data-testid="bulk-stock-unlock" disabled={busy} title="Stoku SGS'den al" onClick={() => run({ stock_unlock: true }, "Stok bir sonraki senkronda SGS'den güncellenecek.")}
              className="kz-btn-outline text-sm py-2 px-3"><RotateCcw size={14}/></button>
          </div>
          <p className="text-[11px] text-ink-500 mt-1">Manuel stok senkronizasyonda ezilmez.</p>
        </div>
      </div>
    </div>
  );
}
